"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES, VIDEO_FILE_TYPES } from "@/libs/builder/consts";

export const heroWithCardsDefaultValues = {
  backgroundType: "image",
  mobileVariant: "transparentContentOnTop",
  videoFileReference: "",
  tabletVideoFileReference: "",
  mobileVideoFileReference: "",
  displayScrollBar: false,
  displayLoader: false,
  logoReference: "",
  clipped: false,
  legalDisclaimer: "Legal Disclaimer",
  desktopImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ffca99c7ff4421f904e63edc9935589",
    title: "desktopImage",
    alt: "desktopImage",
  },
  smallImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F8ffca99c7ff4421f904e63edc9935589",
    title: "smallImage",
    alt: "smallImage",
  },
  content: {
    title: "Title",
    tagLine: "XPRESS YOUR UNIQUENESS",
    text: "Description",
    cta: [
      {
        additionalBehavior: "always",
        label: "Button",
        theme: "light",
        layout: "full",
        tracking: "tracking",
        link: "/",
        openIn: "new Tab",
        target: "",
      },
    ],
    discounts: [
      {
        currentPrice: "CHF 19.90",
        originalPrice: "CHF 29.90",
        packInformation: "Per pack",
        priceDisclaimer: "Offer available until 31/10/2023",
      },
    ],
    cards: [
      {
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F41dd5c0e31aa463fb262c7a3a0438cf9",
          title: "cardImage",
          alt: "cardImage",
        },
        link: "/",
        label: "How does Ploom work",
        altText: "Card",
        openIn: "",
      },
      {
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F41dd5c0e31aa463fb262c7a3a0438cf9",
          title: "cardImage",
          alt: "cardImage",
        },
        link: "/",
        label: "How does Ploom work",
        altText: "Card",
        openIn: "",
      },
      {
        image: {
          src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F41dd5c0e31aa463fb262c7a3a0438cf9",
          title: "cardImage",
          alt: "cardImage",
        },
        link: "/",
        label: "How does Ploom work",
        altText: "Card",
        openIn: "",
      },
    ],
  },
};

export const heroWithCardsInputs = [
  {
    name: "data",
    type: "object",
    required: true,
    subFields: [
      {
        name: "backgroundType",
        type: "string",
        enum: ["image", "video"],
        required: true,
        defaultValue: "image",
      },
      {
        name: "mobileVariant",
        type: "string",
        defaultValue: "transparentContentOnTop",
        enum: ["transparentContentOnTop", "contentAtTheBottomWithBackground"],
        required: true,
      },
      {
        name: "logo",
        type: "file",
        required: true,
        allowedFileTypes: IMAGE_FILE_TYPES,
      },
      {
        name: "logoAlt",
        type: "string",
        defaultValue: "Logo",
      },
      {
        name: "logoWidth",
        type: "number",
      },
      {
        name: "logoHeight",
        type: "number",
      },
      {
        name: "content",
        type: "object",
        defaultValue: {
          title: "Title",
        },
        required: true,
        subFields: [
          {
            name: "tagLine",
            type: "string",
          },
          {
            name: "title",
            type: "string",
          },
          {
            name: "titleLogged",
            type: "string",
          },
          {
            name: "subheadline",
            type: "string",
          },
          {
            name: "subheadlineLogged",
            type: "string",
          },
          {
            name: "text",
            type: "string",
          },
          {
            name: "textLogged",
            type: "string",
          },
          {
            name: "cta",
            type: "list",
            subFields: [
              {
                name: "additionalBehavior",
                type: "string",
                defaultValue: "always",
                required: true,
                enum: ["always", "onlyForLoggedIn", "onlyForNotLoggedIn"],
              },
              {
                name: "label",
                type: "string",
                required: true,
              },
              {
                name: "theme",
                type: "string",
                defaultValue: "light",
                enum: ["light", "dark"],
                required: true,
              },
              {
                name: "layout",
                type: "string",
                enum: ["chevron", "full"],
                required: true,
              },
              {
                name: "tracking",
                type: "string",
                required: true,
              },
              {
                name: "link",
                type: "string",
                required: true,
              },
              {
                name: "openIn",
                type: "string",
                enum: ["new Tab", "same Tab"],
                friendlyName: "Open in",
                onChange: `options.set("target", (options.get("openIn") === "new Tab"? "_blank" : ""))`,
                defaultValue: "same Tab",
              },
              {
                hideFromUI: true,
                name: "target",
                type: "string",
                enum: ["", "_blank"],
                required: true,
                defaultValue: "",
              },
            ],
          },
          {
            name: "discounts",
            type: "list",
            required: true,
            subFields: [
              {
                name: "currentPrice",
                type: "string",
                required: true,
              },
              {
                name: "originalPrice",
                type: "string",
                required: true,
              },
              {
                name: "packInformation",
                type: "string",
                required: true,
              },
              {
                name: "priceDisclaimer",
                type: "string",
                required: true,
              },
            ],
          },
          {
            name: "cards",
            type: "list",
            subFields: [
              {
                name: "image",
                type: "object",
                required: true,
                subFields: [
                  {
                    name: "src",
                    type: "file",
                    required: true,
                    allowedFileTypes: IMAGE_FILE_TYPES,
                  },
                  {
                    name: "title",
                    type: "string",
                    required: true,
                  },
                  {
                    name: "alt",
                    type: "string",
                    required: true,
                  },
                ],
              },
              {
                name: "link",
                type: "string",
                required: true,
              },
              {
                name: "label",
                type: "string",
                required: true,
              },
              {
                name: "altText",
                type: "string",
                required: true,
              },
              {
                name: "openInSelect",
                type: "string",
                enum: ["new Tab", "same Tab"],
                friendlyName: "Open in",
                onChange: `options.set("openIn", (options.get("openInSelect") === "new Tab"? "_blank" : ""))`,
                defaultValue: "same Tab",
              },
              {
                hideFromUI: true,
                name: "openIn",
                type: "string",
                enum: ["", "_blank"],
                required: true,
                defaultValue: "",
              },
            ],
          },
        ],
      },
      {
        name: "desktopImage",
        type: "object",
        showIf: `options.get("backgroundType") === "image"`,
        subFields: [
          {
            name: "src",
            type: "file",
            required: true,
            allowedFileTypes: IMAGE_FILE_TYPES,
          },
          {
            name: "title",
            type: "string",
            required: true,
          },
          {
            name: "alt",
            type: "string",
            required: true,
          },
        ],
      },
      {
        name: "mediumImage",
        type: "object",
        showIf: `options.get("backgroundType") === "image"`,
        subFields: [
          {
            name: "src",
            type: "file",
            allowedFileTypes: IMAGE_FILE_TYPES,
            required: true,
          },
          {
            name: "title",
            type: "string",
            required: true,
          },
          {
            name: "alt",
            type: "string",
            required: true,
          },
        ],
      },
      {
        name: "smallImage",
        type: "object",
        showIf: `options.get("backgroundType") === "image"`,
        subFields: [
          {
            name: "src",
            type: "file",
            allowedFileTypes: IMAGE_FILE_TYPES,
            required: true,
          },
          {
            name: "title",
            type: "string",
            required: true,
          },
          {
            name: "alt",
            type: "string",
            required: true,
          },
        ],
      },
      {
        name: "videoFileReference",
        type: "file",
        allowedFileTypes: VIDEO_FILE_TYPES,
        showIf: `options.get("backgroundType") === "video"`,
      },
      {
        name: "tabletVideoFileReference",
        type: "file",
        allowedFileTypes: VIDEO_FILE_TYPES,
        showIf: `options.get("backgroundType") === "video"`,
      },
      {
        name: "mobileVideoFileReference",
        type: "file",
        allowedFileTypes: VIDEO_FILE_TYPES,
        showIf: `options.get("backgroundType") === "video"`,
      },
      {
        name: "displayScrollBar",
        type: "boolean",
        defaultValue: false,
        required: true,
      },
      {
        name: "displayLoader",
        type: "boolean",
        defaultValue: false,
        required: true,
      },
      {
        name: "logoReference",
        type: "string",
      },
      {
        name: "clipped",
        type: "boolean",
        defaultValue: false,
        required: true,
      },
      {
        name: "legalDisclaimer",
        type: "string",
      },
      {
        name: "gradientPosition",
        type: "string",
        enum: ["none", "left", "top"],
        defaultValue: "top",
      },
    ],
    defaultValue: heroWithCardsDefaultValues,
  },
] as const satisfies Inputs;

export const HeroBannerWithCardsComponent: RegisteredComponent = {
  name: "HeroWithCards",
  component: dynamic(async () => await import("./HeroBannerWithCards")),
  inputs: heroWithCardsInputs,
};
